import type { ReactNode } from 'react'
import { ENROLLMENT_PUBLIC_LINKS } from '@/features/enrollment/constants/enrollmentContent'

export type CheckboxAgreementProps = {
  checked: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
  children?: ReactNode
}

export function CheckboxAgreement({
  checked,
  disabled = false,
  onChange,
  children
}: CheckboxAgreementProps) {
  return (
    <label
      className={`group mx-auto mt-6 flex max-w-2xl items-start justify-center gap-3 px-3 py-2 text-[15px] text-gray select-none ${
        disabled ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="absolute opacity-0 w-0 h-0 pointer-events-none"
      />
      <span className="relative mt-0.5 flex shrink-0 items-center justify-center">
        <span
          className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border-2 transition-all duration-200 group-hover:scale-110 group-active:scale-90 ${
            checked
              ? 'border-primary bg-primary shadow-[0_0_0_3px_rgba(230, 83, 0,0.18)]'
              : disabled
                ? 'border-gray-lighter bg-slate-50'
                : 'border-gray-lighter bg-white group-hover:border-primary group-hover:shadow-[0_0_0_3px_rgba(230, 83, 0,0.1)]'
          }`}
        >
          {checked && (
            <svg
              className="h-3 w-3 animate-[bounce-in_0.25s_ease-out] text-white"
              viewBox="0 0 12 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M2 6l3 3 5-5" />
            </svg>
          )}
        </span>
      </span>
      <span
        className={`leading-snug transition-colors duration-200 ${
          checked || disabled ? 'text-gray-dark' : 'group-hover:text-gray'
        }`}
      >
        {children ?? (
          <>
            I agree to the{' '}
            <a href={ENROLLMENT_PUBLIC_LINKS.privacyPolicy} className="text-primary hover:underline">Privacy Policy</a> and{' '}
            <a href={ENROLLMENT_PUBLIC_LINKS.termsOfService} className="text-primary hover:underline">Terms of Service</a> and consent to receive enrollment
            communications by email and SMS.
          </>
        )}
      </span>
    </label>
  )
}
